export default {
  'wallet.add-blacklist': '添加黑名单',
  'wallet.add-currency': '添加币种',
  'wallet.add-external-account': '添加外部账户',
  'wallet.add-webhook': '添加 Webhook',
  'wallet.adjust': '调整',
  'wallet.apply-recharge': '申请充值',
  'wallet.approve': '通过',
  'wallet.cancel': '取消',
  'wallet.change-password': '修改密码',
  'wallet.check-limit': '检查限额',
  'wallet.confirm-adjust': '确认调整',
  'wallet.confirm-consume': '确认消费',
  'wallet.confirm-delete-account': '确认删除子账户',
  'wallet.confirm-delete-blacklist': '确认删除黑名单',
  'wallet.confirm-delete-credential': '确认删除凭证',
  'wallet.confirm-delete-rule': '确认删除规则',
  'wallet.confirm-delete-webhook': '确认删除 Webhook',
  'wallet.confirm-recharge': '确认充值',
  'wallet.confirm-withdraw': '确认提现',
  'wallet.create-batch': '创建批次',
  'wallet.create-credential': '创建凭证',
  'wallet.create-reconciliation-batch': '创建对账批次',
  'wallet.create-reversal': '创建撤销',
  'wallet.create-risk-rule': '创建风控规则',
  'wallet.create-rule': '创建规则',
  'wallet.create-sub-account': '创建子账户',
  'wallet.create-wallet': '创建钱包',
  'wallet.delete': '删除',
  'wallet.detail': '详情',
  'wallet.disable-mfa': '禁用 MFA',
  'wallet.edit': '编辑',
  'wallet.edit-credential': '编辑凭证',
  'wallet.enable-mfa': '启用 MFA',
  'wallet.execute': '执行',
  'wallet.export': '导出',
  'wallet.extend': '延期',
  'wallet.fee-calculator': '手续费计算器',
  'wallet.freeze': '冻结',
  'wallet.handle-expiry': '处理过期',
  'wallet.ignore': '忽略',
  'wallet.init-config': '初始化配置',
  'wallet.query': '查询',
  'wallet.refresh-expiring': '刷新即将过期',
  'wallet.reject': '拒绝',
  'wallet.reset': '重置',
  'wallet.save': '保存',
  'wallet.saved': '已保存',
  'wallet.set-default': '设为默认',
  'wallet.set-limit': '设置限额',
  'wallet.set-password': '设置密码',
  'wallet.test': '测试',
  'wallet.unfreeze': '解冻',
  'wallet.verify': '验证',
  'wallet.view-detail': '查看详情',
  'wallet.not-found.title': '钱包尚未开通',
  'wallet.not-found.description': '正在为您初始化钱包，请稍后刷新页面重试',
  'wallet.not-found.retry': '重试',
  'wallet.create-account': '创建账户',
  'wallet.create-account-success': '账户创建成功',
  'wallet.create-account-failed': '账户创建失败',
  'wallet.my-accounts': '我的账户',
  'wallet.recent-transactions': '最近交易',
  'wallet.currency-code': '币种',
  'wallet.currency-code-required': '请输入币种',
  'wallet.fund-type': '资金类型',
  'wallet.fund-type-required': '请选择资金类型',
};
